var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95399 6.9783L13.4245 2.55122L14.3359 1.63976C14.4661 1.50955 14.4661 1.29253 14.3359 1.11892L13.3811 0.164063C13.2075 0.0338542 12.9905 0.0338542 12.8602 0.164063L7.5217 5.54601L2.13976 0.164063C2.00955 0.0338542 1.79253 0.0338542 1.61892 0.164063L0.664063 1.11892C0.533854 1.29253 0.533854 1.50955 0.664063 1.63976L6.04601 6.9783L0.664063 12.3602C0.533854 12.4905 0.533854 12.7075 0.664063 12.8811L1.61892 13.8359C1.79253 13.9661 2.00955 13.9661 2.13976 13.8359L7.5217 8.45399L11.9488 12.9245L12.8602 13.8359C12.9905 13.9661 13.2075 13.9661 13.3811 13.8359L14.3359 12.8811C14.4661 12.7075 14.4661 12.4905 14.3359 12.3602L8.95399 6.9783Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3e024281c8f210d1af11c6eaeb34abf5.svg";
export { ForwardRef as ReactComponent };